/**
 * Карточка объекта карты: читалка под курсором или та, что закреплена кликом.
 *
 * Правило здесь одно и неочевидное: **закреплённая сильнее наведения**. Иначе
 * стоит увести мышь на соседний объект — и закреплённая карточка подменится
 * читалкой, то есть крестик перестанет быть единственным способом её закрыть.
 *
 * Наведение при этом всё равно запоминаем: закрыв закреплённую, человек часто
 * оставляет курсор на месте, и карточка обязана вернуться читалкой, а не
 * исчезнуть до следующего шевеления мыши.
 *
 * Машина ОБЩАЯ на все такие карточки (землетрясение, рубеж ИЭЗ). Писалась она
 * под землетрясения, и вторая её копия для рубежей разъехалась бы с первой при
 * первой же правке — ровно так расходились палитры карты.
 */
export interface MapCardHit {
  /** Точка привязки: карточка держится ЗА НЕЁ, а не за пиксель курсора
   *  (см. `map/callout.ts` — пиксель перестаёт значить что-либо после пана). */
  lng: number
  lat: number
  props: Record<string, unknown>
}

export interface MapCardState {
  hover: MapCardHit | null
  pinned: MapCardHit | null
}

export const NO_MAP_CARD: MapCardState = { hover: null, pinned: null }

export function onCardHover(state: MapCardState, hit: MapCardHit | null): MapCardState {
  if (state.hover === hit) return state
  return { ...state, hover: hit }
}

export function onCardClick(_state: MapCardState, hit: MapCardHit): MapCardState {
  // Читалку гасим сразу: закреплённая встаёт на её место, и две карточки в
  // одной точке мигнули бы одна поверх другой. Прежнее состояние не нужно —
  // клик задаёт его целиком; аргумент оставлен ради общей формы всех трёх.
  return { hover: null, pinned: hit }
}

export function onCardClose(state: MapCardState): MapCardState {
  return { ...state, pinned: null }
}

/** Что рисовать: карточка и признак «закреплена». */
export function mapCardShown(
  state: MapCardState,
): { hit: MapCardHit; pinned: boolean } | null {
  if (state.pinned) return { hit: state.pinned, pinned: true }
  if (state.hover) return { hit: state.hover, pinned: false }
  return null
}
